export const nombre = (state) => {
  return state.nombre;
};

export const token = (state) => {
  return state.token;
};
